
import { defineComponent, PropType } from "vue";
import LoadingIndicatorVue from "./Spinner.vue";

export default defineComponent({
  components: {
    appLoading: LoadingIndicatorVue,
  },
  props: {
    loading: Boolean,
    disabled: Boolean,
    mode: {
      type: String as PropType<
        "normal" | "info" | "warning" | "danger" | "success"
      >,
      default: "normal",
    },
    variant: {
      type: String as PropType<"contained" | "outlined" | "link">,
      default: "contained",
    },
  },
});
